module.exports = __webpack_public_path__ + "static/media/instagram.5cf7a8ce.svg";